/*
** Voltage Sidebar -- on the right side of the canvas, for scrolling the voltage range
** Copyright (C) 2023-2026 Tactile Interactive, all rights reserved
*/

import React from 'react';
import PropTypes from 'prop-types';
import * as d3 from "d3";

import voltDisplay from './voltDisplay.js';
//import {VOLT_SIDEBAR_WIDTH} from './voltConstants.js';
//new URL("./image.png", import.meta.url);

import downIcon from './voltIcons/downIcon2.png';
import upIcon   from './voltIcons/upIcon2.png';
import minusIcon from './voltIcons/minusIcon2.png';
import plusIcon from './voltIcons/plusIcon2.png';

let traceVoltageSidebar = false;
let traceDragging = false;

const propTypes = {
		// x coordinate of the right edge or the bumper on the right side
		// drawingLeft: PropTypes.number.isRequired,
		// drawingWidth: PropTypes.number.isRequired,
		canvasInnerHeight: PropTypes.number.isRequired,
		bumperWidth: PropTypes.number,

		space: PropTypes.object.isRequired,
	}


function VoltSidebar(props) {
	if (!props) return '';  // too early
	cfpt(propTypes, props);
	let sidebarWidth = props.width ?? 200;  // ?? why is this undeffined?  nothing passed in.

	let mainVDisp = props.space.vDisp;
	if (!mainVDisp) return '';  // too early or first render

	if (!mainVDisp.heightVolts  || mainVDisp.heightVolts <= 0)
		throw `bad heightVolts ${mainVDisp.heightVolts}`

	if (traceVoltageSidebar) {
		console.log(`🍟 V Sidebar rend: width=${sidebarWidth}  heightVolts=${mainVDisp.heightVolts}  `
			+ mainVDisp.minBottom);
	}

	// Hovering  to show/hide voltage - hovering over the sidebar
	// buttons can make the voltage stuff disappear.  these make sure
	// the voltage still shows if the mouse is over the sidebar.
	const vo = document.querySelector('.WaveView .VoltOverlay');
	const pointerEnter = ev => {
		if (vo) vo.style.visibility = 'visible';
	};
	const pointerLeave = ev => {
		if (vo) vo.style.visibility = '';
	};

	// render.  The buttons are almost square.  The + and – are emojis
	// The arrows need the div for alignment.
	return (
		<aside className='VoltSidebar waveButtonPanel'
				onPointerEnter={pointerEnter} onPointerLeave={pointerLeave} >

			<button className='glass scrollUp' onClick={ev => mainVDisp.scrollVoltHandler(+1)}>
				<img src={downIcon} />
			</button>

			<button className='glass zoomIn' onClick={ev => mainVDisp.zoomVoltHandler(-1)}>
				<img src={plusIcon} />
			</button>

			<button className='glass zoomOut' onClick={ev => mainVDisp.zoomVoltHandler(+1)}>
				<img src={minusIcon} />
			</button>

			<button className='glass scrollDown' onClick={ev => mainVDisp.scrollVoltHandler(-1)}>
				<img src={upIcon} />
			</button>

		</aside>
	);
}

export default VoltSidebar;
